export const ADVANCED_VERTICAL_STEPPER_STAGE = {
    FIRST_STAGE: 'first',
    INTERMEDIATE_STAGE: 'intermediate',
    LAST_STAGE: 'last'
};
export const ADVANCED_VERTICAL_STEPPER_GROUP_TYPE = {
    GROUP_ITEM: 'group_item'
};
export const ADVANCED_VERTICAL_STEPPER_TYPE = {
    CONSECUTIVE: 'consecutive',
    NON_CONSECUTIVE: 'non-consecutive'
};
export const ADVANCED_VERTICAL_STEPPER_STATUS = {
    COMPLETE: 'complete',
    ERROR: 'error'
};
//# sourceMappingURL=types.js.map